import { Box, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const UsernameCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Text>{rowData.username}</Text>
        </Box>
    );
};

const UsernameColumn = () => ({
    accessorKey: 'username',
    header: 'Username',
    size: 1,
    Cell: ({ cell }) => <UsernameCell cell={cell} />,
});
export default UsernameColumn;
